export default __webpack_public_path__ + "static/media/deep_search.a2d96a97.mp4";